import classNames from "classnames";
import React, { forwardRef } from "react";

import "./ACPageContainer.less";

const ACPageContainer = forwardRef<
  HTMLDivElement,
  React.HtmlHTMLAttributes<HTMLDivElement>
>(function ACPageContainer({ children, className }, ref) {
  return (
    <div className={classNames("ac-page-container", className)} ref={ref}>
      {children}
    </div>
  );
});

interface SectionProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  borderBottom?: boolean;
  borderTop?: boolean;
  equalPadding?: boolean;
}

const ACPageSection = ({
  children,
  className,
  borderBottom = true,
  borderTop,
  equalPadding,
  ...restDivProps
}: SectionProps) => {
  return (
    <div
      className={classNames("ac-page-section", className, {
        "border-bottom": borderBottom,
        "border-top": borderTop,
        "equal-padding": equalPadding,
      })}
      {...restDivProps}
    >
      {children}
    </div>
  );
};
type ACPageContainerType = typeof ACPageContainer & {
  Section: typeof ACPageSection;
};

Object.assign(ACPageContainer, {
  Section: ACPageSection,
});

export default ACPageContainer as ACPageContainerType;
